import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import NavBar from '../../Components/NavBar/navbar';
import './Auth.css';
import { API_ENDPOINTS } from '../../utils/config';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    const payload = {
      username: formData.username,
      email: formData.email,
      password: formData.password,
      user_type: 'registered'
    };

    try {
      const response = await fetch(API_ENDPOINTS.REGISTER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.status === 201) {
        if (data.verification_sent) {
          setSuccess(
            `Account created. We sent a confirmation email to ${data.email || formData.email}. Open the link in that message to verify your address.`
          );
        } else {
          setSuccess(
            `Account created, but the confirmation email could not be sent${
              data.verification_error ? `: ${data.verification_error}` : '.'
            } Sign in and use Account → Resend verification once mail is configured.`
          );
        }
        setTimeout(() => navigate('/auth/login'), 3500);
      } else {
        setError(data.error || 'Registration failed');
      }
    } catch (err) {
      console.error('Registration request failed:', err);
      setError('Server not responding. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <NavBar />
      <div className="auth-page-main">
        <div className="auth-container">
          <div className="auth-box">
            <div className="auth-brand">
              Evolv<span>e<sup>x</sup></span>
            </div>
            <h2>Create account</h2>
            <p className="auth-subtitle">Join EvolveX</p>

            {error && <div className="auth-error">{error}</div>}
            {success && <div className="auth-success">{success}</div>}

            <form onSubmit={handleRegister}>
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  id="username"
                  type="text"
                  name="username"
                  required
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Choose a username"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="you@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Create a password"
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm password</label>
                <input
                  id="confirmPassword"
                  type="password"
                  name="confirmPassword"
                  required
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm password"
                />
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Creating account…' : 'Register'}
              </button>
            </form>

            <p className="auth-footer">
              Already have an account? <Link to="/auth/login">Sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
